// ---------------------------------------
// Give some time for resources too load
// and then try to scroll or reset hash
// ---------------------------------------
export function scroll( hash ) {

  if ( hash && hash.slice( 0, 1 ) == "#" && $( hash ) ) {
    $( hash ).scrollIntoView( { block: "start", behavior: "smooth" } )
  }

}